import { DataTable } from "@marketplace/ui/data-table";

import { useVoucherListTableColumns } from "../../hooks/use-voucher-list-table-columns";
import type { VoucherListItem } from "../../types";

type VoucherListTableProps = {
  records: VoucherListItem[];
};

export const VoucherListTable: React.FC<VoucherListTableProps> = ({
  records
}) => {
  const { columns } = useVoucherListTableColumns();

  return (
    <div className="overflow-x-auto">
      <DataTable
        minHeight={10}
        columns={columns}
        records={records}
        horizontalSpacing="md"
        verticalSpacing="sm"
      />
    </div>
  );
};
